<template>
  <div>
    <v-dialog v-model="dialog"
              persistent
              scrollable
              width="800"
    >

      <v-card>

        <v-card-title>
          Ajouter des cartes GIFTY pour des BDD
          <v-spacer/>
          <v-icon @click="close">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">

          <v-autocomplete v-model="form.database_ids"
                          :error-messages="errors.database_ids"
                          item-value="id"
                          class="c"
                          multiple
                          chips
                          deletable-chips
                          small-chips
                          :items="databases"
                          item-text="name"
                          outlined
                          background-color="grey lighten-5"
                          label="BDD *"/>

          <v-select v-model="template"
                    item-value="id"
                    clearable
                    :items="templates"
                    item-text="title"
                    outlined
                    background-color="grey lighten-5"
                    label="Modèle *"/>

          <v-row>
            <v-col cols="6">
              <v-text-field outlined
                            label="Solde globale"
                            dense
                            hide-details="auto"
                            :error-messages="errors.balance"
                            v-model="form.balance"></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field outlined
                            label="Solde à crédit"
                            dense
                            hide-details="auto"
                            :error-messages="errors.credit_balance"
                            v-model="form.credit_balance"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                  outlined
                  type="date"
                  clearable
                  label="Date d'expiration (optionnelle)"
                  dense
                  hide-details="auto"
                  :error-messages="errors.expired_at"
                  v-model="form.expired_at"
              />
            </v-col>

          </v-row>


        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn dark
                 color="gifty"
                 :loading="isLoading"
                 depressed
                 @click="saveData">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>
  </div>
</template>

<script>

import {HTTP} from "@/http-common";

export default {
  props: ['templates', 'databases'],
  data() {
    return {
      isLoading: false,
      dialog: false,
      form: {
        database_ids: [],
      },
      template: null,
      errors: {},
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.resetForm()
    },
    saveData() {
      this.errors = {}
      this.isLoading = true

      const formData = new FormData()

      formData.append('balance', this.form.balance ?? "")
      formData.append('credit_balance', this.form.credit_balance ?? "")
      formData.append('expired_at', this.expired_at ?? "")
      formData.append('template', this.template ?? "")

      this.form.database_ids.forEach((id, index) => {
        formData.append(`database_ids[${index}]`, id)
      })

      HTTP.post('/v1/account-cards/store-by-db', formData).then(() => {
        this.isLoading = false
        this.dialog = false
        this.$emit('refresh')
        this.$successMessage = "Le solde a été ajouté et un traitement est en cours.";
        this.resetForm()
      }).catch(err => {
        this.isLoading = false
        this.errors = err.response.data.errors
        this.$errorMessage = "Une erreur s'est produite veuillez corriger et réessayer."
        console.log(err)
      })
    },

    resetForm() {
      this.form.database_ids = []
      this.form.balance = null
      this.form.credit_balance = null
      this.template = null
      this.expired_at = null
      this.errors = {}
    }
  }
}
</script>
<style>
.c .v-chip:not(.v-chip--active),
.c .v-chip:not(.v-chip--active) .v-icon {
  background: #d60c56 !important;
  color: white !important;
}
</style>
